import { queryKeys } from "@/lib/queryClient";
import { fetchUserAnnouncements } from "@/services/announcements.service";
import type { UserAnnouncementRow } from "@/types/announcements";
import { useQuery } from "@tanstack/react-query";

const ANNOUNCEMENTS_STALE_MS = 60 * 1000;
const ANNOUNCEMENTS_POLL_MS = 5 * 60 * 1000;
const FETCH_LIMIT = 50;

export function useAnnouncements(opts: { userId: string | undefined; enabled: boolean }) {
  return useQuery({
    queryKey: queryKeys.announcements(opts.userId),
    queryFn: async (): Promise<UserAnnouncementRow[]> => {
      const rows = await fetchUserAnnouncements(FETCH_LIMIT);
      if (rows === null) {
        throw new Error("Failed to load announcements");
      }
      return rows;
    },
    enabled: Boolean(opts.enabled && opts.userId),
    staleTime: ANNOUNCEMENTS_STALE_MS,
    refetchInterval: ANNOUNCEMENTS_POLL_MS,
  });
}

export function announcementsHasUnreadBell(rows: UserAnnouncementRow[]): boolean {
  if (!rows.length) return false;
  return rows.some((r) => r.has_unread_bell);
}
